import { render, staticRenderFns } from "./UserExchangeFormLinkLogbook.vue?vue&type=template&id=953b4cf4&scoped=true"
import script from "./UserExchangeFormLinkLogbook.vue?vue&type=script&lang=js"
export * from "./UserExchangeFormLinkLogbook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953b4cf4",
  null
  
)

export default component.exports